import { Divider, LoadingSkeleton } from '@joor/design-system'
import styled from 'styled-components'

export enum LoadingFinancialSummaryWidgetTestIds {
  Container = 'loading-financial-summary-widget-container',
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 4px;
`

const StyledDivider = styled(Divider)`
  > div {
    margin: 0 0 8px 0;
  }
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;

  & > div:first-child {
    width: 50%;
  }
  & > div:nth-child(2) {
    width: 30%;
    padding-right: 9px;
  }

  .align-right {
    text-align: right;
  }
`

const StyledRow = styled(Row)`
  background-color: var(--color-primary-100);
  padding: 15px 0 6px 13px;
`

export const LoadingFinancialSummaryWidget = () => (
  <Container data-testid={LoadingFinancialSummaryWidgetTestIds.Container}>
    <Row>
      <LoadingSkeleton count={3} />
      <LoadingSkeleton count={3} />
    </Row>
    <StyledDivider />
    <Row>
      <LoadingSkeleton count={1.7} />
      <LoadingSkeleton />
    </Row>
    <StyledDivider />
    <Row>
      <LoadingSkeleton />
      <LoadingSkeleton width="38%" className="align-right" />
    </Row>
    <StyledRow>
      <LoadingSkeleton />
      <LoadingSkeleton width="70%" className="align-right" />
    </StyledRow>
  </Container>
)
